var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"spinner"},[_c('v-progress-circular',{attrs:{"indeterminate":"","height":2,"color":"primary"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }